import React from 'react'
import './Notfound.css'

const Notfound = () => {
  return (
    <div className='NotFound-main'></div>
  )
}

export default Notfound